module.exports = __webpack_public_path__ + "static/media/icon-reset.8ecb2d15.svg";